import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import React, { useState } from 'react'
import { TitleText } from '../../../component/layout/layoutMainStyle'
import ButtonCustom from '../../../component/button/buttonCustom'
import { icons } from '../../../constants/images'
import { useDropzone } from 'react-dropzone'
import { swalActive, swalError, swalSuccess } from '../../../component/notification/swal'
import FolderApi from '../../../api/folder/folder.api'
import ClearIcon from '@mui/icons-material/Clear';

type PropsDialog = {
    openDialog: boolean
    setOpenDialog: any
    inputFolder: any
    clearErrorMessage?: any
    errorMessage?: any
    loadData: any
    loadDataLevel: any
    level1: any
    setLevel1: any
    setLevel2: any
    setLevel3: any
    setLevel4: any
    setLevelFiles: any
}

export default function DialogIndex(props: PropsDialog) {
    const { openDialog, setOpenDialog, inputFolder, level1, loadData, loadDataLevel, setLevel1, setLevel2, setLevel3, setLevel4, setLevelFiles } = props
    const [files, setFiles] = useState<any>([])
    const [loadingFile, setLoadingFile] = useState<boolean>(false)
    const { getRootProps, getInputProps, open, acceptedFiles, fileRejections } = useDropzone({
        noClick: true,
        noKeyboard: true,
        maxSize: 10000000,
        maxFiles: 1,
        accept: {
            'text/csv': ['.csv'],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
        },
        onDropRejected: (fileRejections) => {
            swalError(fileRejections[0].errors.map((x) => x.code === 'file-invalid-type' ? 'ไม่สามารถเพิ่มไฟล์ประเภทนี้ได้' : x.code === 'file-too-large' ? 'ไฟล์มีขนาดใหญ่เกินไป' : 'ไม่สามารถเพิ่มไฟล์นี้ได้').join('/'))
        },
        onDrop(acceptedFiles, fileRejections, event) {
            setFiles(acceptedFiles)
        },
    });
    const handleUpload = async () => {

        setLoadingFile(true)
        const formData = new FormData();

        files.forEach((item: any) => {
            formData.append("file", item)

        })

        const idFolder = inputFolder.idReferFolder

        await FolderApi.postImportIndex(idFolder, formData).then(async (res) => {
            if (res?.data?.success) {
                if (inputFolder?.stepView === 1) {
                    const data = await loadDataLevel(res?.data?.result?.idFolder)
                    const newArray = new Array(inputFolder.layer)
                    setLevel1([
                        data,
                        ...level1
                    ])
                    loadData()
                }
                if (inputFolder?.stepView === 2) {
                    const data = await loadDataLevel(inputFolder.idReferFolder)
                    const newArray = new Array(inputFolder.layer)

                    setLevel2([
                        ...newArray,
                        ...data.detailFolders,
                    ])
                }
                if (inputFolder?.stepView === 3) {
                    const data = await loadDataLevel(inputFolder.idReferFolder)
                    const newArray = new Array(inputFolder.layer)

                    setLevel3([
                        ...newArray,
                        ...data.detailFolders,
                    ])
                }
                if (inputFolder?.stepView === 4) {
                    const data = await loadDataLevel(inputFolder.idReferFolder)
                    const newArray = new Array(inputFolder.layer)

                    setLevel4([
                        ...newArray,
                        ...data.detailFolders,
                    ])
                }
                if (inputFolder?.stepView === 5) {
                    const data = await loadDataLevel(res?.data?.result?.idFolder)
                    const newArray = new Array(inputFolder.layer)

                    setLevelFiles([...newArray, ...data])
                }
                setLoadingFile(false)
                setOpenDialog(false)
                swalSuccess("นำเข้าดัชนีสำเร็จ")
            } else {
                setLoadingFile(false)
                swalError(res.response.data.description || res.response.data.message);
            }

        }).catch((error: any) => {
            setLoadingFile(false)
            swalError(error.response.data.description || error.response.data.message);
        })
    }
    return (
        <Dialog
            open={openDialog}
            keepMounted
            onClose={() => {
                setOpenDialog(false)
                setFiles([])
            }}
            fullWidth
            maxWidth='sm'
        >
             <DialogTitle sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ClearIcon sx={{ cursor: 'pointer', fontSize: "20px" }} onClick={() => {
                    setOpenDialog(false)
                    setFiles([])
                }} />
            </DialogTitle>
            <DialogContent sx={{ padding: '32px 24px', gap: '22px', display: 'flex', flexDirection: "column" }}>
                <Box sx={{ display: "flex", justifyContent: 'center', width: '100%' }}>
                    <TitleText>
                        นำเข้าดัชนี
                    </TitleText>
                </Box>
                {files.length > 0 ? <Box sx={{ padding: '40px' }}>
                    {files?.map((item: any) => {
                        return (
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between' }}>
                                    <icons.file style={{ marginRight: "16px" }} /> <Typography>{item?.name}</Typography>
                                </Box>
                                <icons.sup_trash style={{ cursor: "pointer" }} onClick={() => setFiles([])} /></Box>
                        )
                    })}
                </Box> :
                    <Box sx={{ padding: '40px' }}>
                        <div style={{
                            borderRadius: '10px',
                            border: '1px dashed #C1C3C7',
                            padding: '56px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '529px'
                        }} {...getRootProps({ className: 'dropzone' })}>
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                                <icons.uploadCloud />
                                <Typography sx={{ fontSize: '14px', fontWeight: '500', marginTop: '24px' }}>ลากหรือเลือกไฟล์เพื่ออัปโหลด</Typography>
                                <Typography sx={{ fontSize: '14px', fontWeight: '300', color: 'rgba(0, 0, 0, 0.40)', marginBottom: '24px' }}>ขนาดไม่เกิน 10MB</Typography>
                                <ButtonCustom variant={'outlined'}
                                    // endIcon={<icons.downloadButton />}
                                    textButton={'เลือกไฟล์'}
                                    onClick={open}
                                    btnStyle={{
                                        '&.MuiButton-outlined': {
                                            color: `#0A77FF !important`,
                                            border: `1px dashed #0A77FF !important`,
                                            backgroundColor: '#fff !important',
                                            borderRadius: "10px !important",
                                            '&:hover': {
                                                color: `#0A77FF  !important`,
                                                border: `1px dashed #0A77FF !important`,
                                                backgroundColor: '#fff !important'
                                            },
                                        },
                                    }} />
                            </div>
                            <input {...getInputProps()} />

                        </div>

                    </Box>}

                <ButtonCustom disabled={loadingFile} textButton={'นำเข้า'} style={{ margin: "auto" }} onClick={() => {
                    swalActive(
                        `ยืนยันที่จะนำเข้าหรือไม่?`,
                        null, (res: any) => {
                            if (res) {
                                handleUpload()
                            }
                        })

                }} />
            </DialogContent>

        </Dialog>
    )
}
